import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <h2 className='about--h2'>About This App</h2>
      <p className='about--p'>
        List important tasks so you can win the day and make a habit of winning!
      </p>
      <p className='about--p version'>Version: 0.9</p>
    </Fragment>
  );
};

export default About;
